/* unplugin-vue-components disabled */import { render } from "./ScenicFoodInfoDetailContent.vue?vue&type=template&id=2a943d1c&ts=true"
import script from "./ScenicFoodInfoDetailContent.vue?vue&type=script&lang=ts"
export * from "./ScenicFoodInfoDetailContent.vue?vue&type=script&lang=ts"

import "./ScenicFoodInfoDetailContent.vue?vue&type=style&index=0&id=2a943d1c&lang=scss"

import exportComponent from "D:\\taiwan-bike-map\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__